module.exports = __webpack_public_path__ + "img/1448606878.a159feab.jpg";